import {
    type ChangePasswordResponseType,
    type ChangePasswordRequestType
} from "./type";
import md5 from "md5";
import {
    request
} from "../request";

const changePassword = async (params: ChangePasswordRequestType): Promise<ChangePasswordResponseType> => {
    return await request<ChangePasswordResponseType>("/admin/changePassword", {
        body: JSON.stringify({
            oldPassword: md5(params.oldPassword),
            newPassword: md5(params.newPassword)
        }),
        method: "PUT"
    });
};

export default changePassword;
